import React from "react";
import useWindowDimensions from "../../tools/useWindowDimensions";

const YouTubeWidget = (props) => {
	const {  width } = useWindowDimensions();
	let widgetWidth = Math.min(width, 853) - 48;
	let widgetHeight = parseInt(widgetWidth / 2);
		return <div>
			<iframe
				width={widgetWidth}
				height={widgetHeight}
				src={`https://www.youtube.com/embed/${props.embedId}`}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				title="Embedded youtube"
			/>
		</div>
	}
;

export default YouTubeWidget;